import type { VariantImagesDefinition } from 'types/images'

import type { M01_IMAGES } from './default'
import { M01_MEMOJI_OLDER_IMAGES } from './memoji-older'
import { M01_REALISTIC_IMAGES } from './realistic'

export const M01_REALISTIC_OLDER_IMAGES = {
  ...M01_REALISTIC_IMAGES,
  problemAreasPitch: M01_MEMOJI_OLDER_IMAGES.problemAreasPitch,
  socialProofMillions: {
    pitch: {
      ...M01_REALISTIC_IMAGES.socialProofMillions.pitch,
      srcSet: [
        '/images/m01/realistic-older/social_proof_millions.webp',
        '/images/m01/realistic-older/social_proof_millions@2x.webp',
      ],
    },
    group: {
      ...M01_REALISTIC_IMAGES.socialProofMillions.group,
      srcSet: [
        '/images/m01/realistic-older/social-proof-millions/group.webp',
        '/images/m01/realistic-older/social-proof-millions/group@2x.webp',
      ],
    },
  },
  experience: {
    background: {
      ...M01_REALISTIC_IMAGES.experience.background,
      srcSet: [
        '/images/m01/realistic-older/experience.webp',
        '/images/m01/realistic-older/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      ...M01_REALISTIC_IMAGES.experiencePitch.pitch,
      srcSet: [
        '/images/m01/realistic-older/experience_pitch.webp',
        '/images/m01/realistic-older/experience_pitch@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      ...M01_REALISTIC_IMAGES.howOftenExercise.background,
      srcSet: [
        '/images/m01/realistic-older/how_often_exercise.webp',
        '/images/m01/realistic-older/how_often_exercise@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      ...M01_REALISTIC_IMAGES.howOftenWalks.background,
      srcSet: [
        '/images/m01/realistic-older/how_often_walks.webp',
        '/images/m01/realistic-older/how_often_walks@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      ...M01_REALISTIC_IMAGES.flexible.background,
      srcSet: [
        '/images/m01/realistic-older/flexible.webp',
        '/images/m01/realistic-older/flexible@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      ...M01_REALISTIC_IMAGES.waterIntake.header,
      srcSet: [
        '/images/m01/realistic-older/water_intake.webp',
        '/images/m01/realistic-older/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      ...M01_REALISTIC_IMAGES.sleepDuration.header,
      srcSet: [
        '/images/m01/realistic-older/sleep_duration.webp',
        '/images/m01/realistic-older/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      ...M01_REALISTIC_IMAGES.wellnessProfile.extended,
      srcSet: [
        '/images/m01/realistic-older/wellness-profile/wellness_profile_overweight.webp',
        '/images/m01/realistic-older/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      ...M01_REALISTIC_IMAGES.wellnessProfile.fullFigured,
      srcSet: [
        '/images/m01/realistic-older/wellness-profile/wellness_profile_bigger.webp',
        '/images/m01/realistic-older/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      ...M01_REALISTIC_IMAGES.wellnessProfile.midSized,
      srcSet: [
        '/images/m01/realistic-older/wellness-profile/wellness_profile_medium_build.webp',
        '/images/m01/realistic-older/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      ...M01_REALISTIC_IMAGES.wellnessProfile.slim,
      srcSet: [
        '/images/m01/realistic-older/wellness-profile/wellness_profile_slender.webp',
        '/images/m01/realistic-older/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    beforeBigger: {
      ...M01_REALISTIC_IMAGES.subscription.beforeBigger,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_bigger.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    beforeMediumBuild: {
      ...M01_REALISTIC_IMAGES.subscription.beforeMediumBuild,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_medium_build.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    beforeSignificantlyOverweight: {
      ...M01_REALISTIC_IMAGES.subscription.beforeSignificantlyOverweight,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_significantly_overweight.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    beforeSlender: {
      ...M01_REALISTIC_IMAGES.subscription.beforeSlender,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_slender.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_before_slender@2x.webp',
      ],
    },
    afterAthletic: {
      ...M01_REALISTIC_IMAGES.subscription.afterAthletic,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_athletic.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    afterBitLeaner: {
      ...M01_REALISTIC_IMAGES.subscription.afterBitLeaner,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_a_bit_leaner.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    afterExtraBulky: {
      ...M01_REALISTIC_IMAGES.subscription.afterExtraBulky,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_extra_bulky.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    afterShredded: {
      ...M01_REALISTIC_IMAGES.subscription.afterShredded,
      srcSet: [
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_shredded.webp',
        '/images/m01/realistic-older/subscription/goal-body/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
  consistencyPitch: {
    pitch: {
      ...M01_REALISTIC_IMAGES.consistencyPitch.pitch,
      srcSet: [
        '/images/m01/realistic-older/consistency-pitch/consistency_pitch.webp',
        '/images/m01/realistic-older/consistency-pitch/consistency_pitch@2x.webp',
      ],
    },
  },
} satisfies VariantImagesDefinition<typeof M01_IMAGES>
